export const DELIVERY_AFTER_PREVIEW_VALUE = 'after_preview';

export const DELIVERY_OPTIONS = [
  {
    value: DELIVERY_AFTER_PREVIEW_VALUE,
    label: 'Decide after preview',
    description: 'Confirm digital or printed delivery after reviewing the preview',
    price: null
  },
  {
    value: 'digital',
    label: 'Digital version',
    description: 'Readable digital version delivered after approval',
    price: 29.99
  },
  {
    value: 'print',
    label: 'Printed hardcover book',
    description: 'High-quality hardcover, shipped to your address',
    price: 49.99
  },
  {
    value: 'premium',
    label: 'Digital + printed book',
    description: 'Digital version and printed hardcover together',
    price: 59.99,
    aliases: ['both']
  }
];

export function getDeliveryOption(preference) {
  return DELIVERY_OPTIONS.find((option) => (
    option.value === preference || (option.aliases || []).includes(preference)
  )) || null;
}

export function normalizeDeliveryPreference(preference) {
  return getDeliveryOption(preference)?.value || '';
}

export function isValidDeliveryPreference(preference) {
  return Boolean(getDeliveryOption(preference));
}

export function getPriceByDeliveryPreference(preference) {
  const option = getDeliveryOption(preference);

  return option ? option.price : null;
}

export function formatPrice(price, currencySymbol = '$') {
  if (price === null || price === undefined || price === '') {
    return 'TBD';
  }

  return `${currencySymbol}${Number(price).toFixed(2)}`;
}
